import { render, staticRenderFns } from "./PhotoCarouselModal.vue?vue&type=template&id=0e1135dc&"
import script from "./PhotoCarouselModal.vue?vue&type=script&lang=js&"
export * from "./PhotoCarouselModal.vue?vue&type=script&lang=js&"
import style0 from "./PhotoCarouselModal.vue?vue&type=style&index=0&id=0e1135dc&prod&%23scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports